export default (data = []) => {
  return data.map(item => {
    if (item) {
      item.name = item.month;
    }
    return item;
  });
};
